import format from 'date-fns/format';

export const displayDate = date => (date ? format(new Date(date), 'dd/MM/yyyy') : '');

export const inputDate = date => (date ? format(new Date(date), 'yyyy-MM-dd') : '');
